import { css, keyframes } from '@emotion/react'
import { mediaQuery, typo } from '@mathflat/common/style'

const academyArrowSend = keyframes`
  0% {
    transform: translate(0, 0);
    opacity: 1;
  }
  45% {
    transform: translate(4px, -4px);
    opacity: 0;
  }
  46% {
    transform: translate(-4px, 4px);
    opacity: 0;
  }
  100% {
    transform: translate(0, 0);
    opacity: 1;
  }
`

/**
 * 말풍선 8초 주기 — 왼쪽 10px 에서 들어와(0.5s) → 오른쪽 5px · 2px 툭툭 → 약 4초 노출 → 사라진 채 약 3초.
 */
const bubbleCycle = keyframes`
  0% {
    opacity: 0;
    transform: translate(-10px, -50%);
  }
  6% {
    opacity: 1;
    transform: translate(0, -50%);
  }
  12% {
    transform: translate(5px, -50%);
  }
  15% {
    transform: translate(0, -50%);
  }
  18% {
    transform: translate(2px, -50%);
  }
  21%,
  55% {
    opacity: 1;
    transform: translate(0, -50%);
  }
  61%,
  100% {
    opacity: 0;
    transform: translate(-6px, -50%);
  }
`

const S = {
  link: css`
    position: relative;
    appearance: none;
    border: none;
    background: none;
    font-family: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 12px 16px;
    border-radius: var(--Radius-300);
    ${typo.heading05};
    font-weight: 500;
    color: var(--Colors-Gray-700);
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      background: var(--Colors-Gray-100);

      /* hover 중에는 주기와 무관하게 말풍선을 고정한다 */
      .academy-bubble {
        animation: none;
        opacity: 1;
        transform: translate(0, -50%);
      }

      .academy-link-arrow {
        animation: ${academyArrowSend} 0.85s ease-in-out infinite;

        @media (prefers-reduced-motion: reduce) {
          animation: none;
        }
      }
    }

    &:active {
      background: var(--Colors-Gray-200);
    }
  `,
  arrow: css`
    flex-shrink: 0;
    transform-box: fill-box;
    transform-origin: center;
  `,
  /* absolute 라 GNB 너비에 영향을 주지 않는다 */
  bubble: css`
    position: absolute;
    top: 50%;
    left: calc(100% + 4px);
    padding: 4px 12px;
    border-radius: 999px;
    background: var(--Colors-Sky-50);
    ${typo.caption01};
    font-weight: 700;
    color: var(--Colors-Sky-400);
    white-space: nowrap;
    pointer-events: none;
    animation: ${bubbleCycle} 8s 0.6s ease-out infinite both;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: -4px;
      width: 8px;
      height: 8px;
      background: var(--Colors-Sky-50);
      transform: translateY(-50%) rotate(45deg);
    }

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      opacity: 1;
      transform: translate(0, -50%);
    }

    /* 좁은 화면에서는 오른쪽 헤더 메뉴와 겹치지 않도록 짧은 문구로 바꾼다 */
    .academy-bubble-short {
      display: none;
    }

    ${mediaQuery.large} {
      .academy-bubble-full {
        display: none;
      }
      .academy-bubble-short {
        display: inline;
      }
    }
  `,
}

export default S
